export default __webpack_public_path__ + "static/blog_img-4205ab8c53c76bfa6d61913a8e868047.svg";